( function( $ ){

	var Viewport = {};

	Viewport.documentWidth = function(){
		var e = window, a = 'inner';
			if (!('innerWidth' in window )) {
			  a = 'client';
			  e = document.documentElement || document.body;
			}
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };

	};

	var Video = {};

	Video.scroll = function(){

		var introVideo = $( '.banner-header' );
		var set = 0;

		introVideo.find( '#scrolltoVideo' ).on( 'click', function(){

			if( Viewport.documentWidth().width <= 767 ){
				set = 80;
			}else{
				set = 10;
			}

			$('html,body').animate({
				  scrollTop: $( '.intro-video' ).offset().top - set
			  }, 500 );
			});

	};

	$( document ).ready( function(){
		//Video.scroll();
	});

}) (jQuery);
